(function(){ try {var elementStyle = document.createElement('style'); elementStyle.appendChild(document.createTextNode(".base-icon[data-v-a4d3a6a3]{width:1em;height:1em;vertical-align:-.15em;fill:currentColor;overflow:hidden}.img-preview[data-v-a123ab81]{user-select:none;background-color:#00000080;position:fixed;top:0;left:0;z-index:9999;width:100vw;height:100vh;display:flex;align-items:center;justify-content:center}.img-preview .image-view[data-v-a123ab81]{max-width:100%;transition:.3s transform;position:relative;cursor:move}.img-preview .image-view.no-animate[data-v-a123ab81]{transition:none!important}.img-preview .button[data-v-a123ab81]{background-color:#6e6e6eb3;cursor:pointer;color:#fff;display:flex;justify-content:center;align-items:center}.img-preview .close[data-v-a123ab81]{position:absolute;top:20px;right:20px;width:30px;height:30px;font-size:20px}.img-preview .arrow[data-v-a123ab81]{position:absolute;top:50%;transform:translateY(-50%);width:35px;height:35px;font-size:30px}.img-preview .arrow.arrow-left[data-v-a123ab81]{left:30px}.img-preview .arrow.arrow-right[data-v-a123ab81]{right:30px}.img-preview .options[data-v-a123ab81]{position:absolute;bottom:70px;left:50%;transform:translate(-50%);display:flex;font-size:18px}.img-preview .options .option[data-v-a123ab81]{width:30px;height:30px;margin-left:2px;margin-right:2px}.img-preview .imgs[data-v-a123ab81]{position:absolute;bottom:10px;left:50%;transform:translate(-50%);text-align:center;width:100%;overflow-x:hidden;white-space:nowrap}.img-preview .imgs[data-v-a123ab81]:hover{overflow-x:overlay}.img-preview .imgs[data-v-a123ab81]::-webkit-scrollbar{width:7px;height:7px}.img-preview .imgs[data-v-a123ab81]::-webkit-scrollbar-track-piece{background-color:transparent}.img-preview .imgs[data-v-a123ab81]::-webkit-scrollbar-thumb{background-color:#ffffff80;background-clip:padding-box;min-height:28px;border-radius:5px;transition:.3s background-color}.img-preview .imgs[data-v-a123ab81]::-webkit-scrollbar-thumb:hover{background-color:#ffffff80}.img-preview .imgs .img[data-v-a123ab81]{width:50px;height:50px;display:inline-flex;justify-content:center;align-items:center;margin-left:5px;margin-right:5px}.img-preview .imgs .img.selected[data-v-a123ab81]{background-color:#ef544eb3}.img-preview .imgs .img>img[data-v-a123ab81]{width:80%;height:80%;object-fit:cover}.image-wrapper[data-v-2cd4f323]{display:inline-block}.image-wrapper[data-v-2cd4f323] img{cursor:pointer}.vue3-image-preview-disabled-scroll{overflow:hidden!important}")); document.head.appendChild(elementStyle);} catch(e) {console.error('vite-plugin-css-injected-by-js', e);} })();import { defineComponent as S, openBlock as f, createElementBlock as h, createElementVNode as m, reactive as q, computed as L, onMounted as H, onUnmounted as j, toRefs as P, resolveComponent as x, normalizeClass as k, normalizeStyle as D, createVNode as p, Fragment as C, createCommentVNode as _, renderList as F, renderSlot as R, createApp as G } from "vue";
const U = S({
  name: "BaseIcon",
  props: {
    icon: {
      type: String,
      required: !0
    }
  }
});
const M = (t, e) => {
  const o = t.__vccOpts || t;
  for (const [r, s] of e)
    o[r] = s;
  return o;
}, W = {
  class: "base-icon",
  "aria-hidden": "true"
}, Z = ["xlink:href"];
function J(t, e, o, r, s, l) {
  return f(), h("svg", W, [
    m("use", {
      "xlink:href": "#icon-" + t.icon
    }, null, 8, Z)
  ]);
}
const K = /* @__PURE__ */ M(U, [["render", J], ["__scopeId", "data-v-a4d3a6a3"]]);
class T {
  /**
   * 求和(解决计算精度问题)
   *
   * @params arg1
   * @params arg2
   * @return {}
   * @author mxw
   * @Date 2022/12/2
   */
  static sum(e, o) {
    let r, s;
    try {
      r = e.toString().split(".")[1].length;
    } catch {
      r = 0;
    }
    try {
      s = o.toString().split(".")[1].length;
    } catch {
      s = 0;
    }
    const l = Math.abs(r - s), a = Math.pow(10, Math.max(r, s));
    if (l > 0) {
      const n = Math.pow(10, l);
      r > s ? (e = Number(e.toString().replace(".", "")), o = Number(o.toString().replace(".", "")) * n) : (e = Number(e.toString().replace(".", "")) * n, o = Number(o.toString().replace(".", "")));
    } else
      e = Number(e.toString().replace(".", "")), o = Number(o.toString().replace(".", ""));
    return (e + o) / a;
  }
  /**
   * 相减(解决计算精度问题)
   *
   * @params arg1
   * @params arg2
   * @return {}
   * @author mxw
   * @Date 2022/12/2
   */
  static sub(e, o) {
    let r, s;
    try {
      r = e.toString().split(".")[1].length;
    } catch {
      r = 0;
    }
    try {
      s = o.toString().split(".")[1].length;
    } catch {
      s = 0;
    }
    const l = Math.abs(r - s), a = Math.pow(10, Math.max(r, s));
    if (l > 0) {
      const n = Math.pow(10, l);
      r > s ? (e = Number(e.toString().replace(".", "")), o = Number(o.toString().replace(".", "")) * n) : (e = Number(e.toString().replace(".", "")) * n, o = Number(o.toString().replace(".", "")));
    } else
      e = Number(e.toString().replace(".", "")), o = Number(o.toString().replace(".", ""));
    return (e - o) / a;
  }
  /**
   * 相乘(解决计算精度问题)
   *
   * @params arg1
   * @params arg2
   * @return {}
   * @author mxw
   * @Date 2022/12/2
   */
  static mul(e, o) {
    let r = 0;
    const s = e.toString(), l = o.toString();
    try {
      r += s.split(".")[1].length;
    } catch (a) {
      console.log(a);
    }
    try {
      r += l.split(".")[1].length;
    } catch (a) {
      console.log(a);
    }
    return Number(s.replace(".", "")) * Number(l.replace(".", "")) / Math.pow(10, r);
  }
  /**
   * 相除(解决计算精度问题)
   *
   * @params arg1
   * @params arg2
   * @return {}
   * @author mxw
   * @Date 2022/12/2
   */
  static div(e, o) {
    let r = 0, s = 0;
    try {
      r = e.toString().split(".")[1].length;
    } catch (n) {
      console.log(n);
    }
    try {
      s = o.toString().split(".")[1].length;
    } catch (n) {
      console.log(n);
    }
    const l = Number(e.toString().replace(".", "")), a = Number(o.toString().replace(".", ""));
    return l / a * Math.pow(10, s - r);
  }
  /**
   * 保留pow位小数，超出pow位小数往前进位
   *
   * @params num 数值
   * @params pow 小数位数
   * @return {}
   * @author mxw
   * @Date 2022/12/14
   */
  static ceil(e, o) {
    return Math.ceil(e * Math.pow(10, o)) / Math.pow(10, o);
  }
}
class Q {
  /**
   * 异步函数
   *
   * @param {any} fn 执行函数
   * @param {any} t 时间
   * @return {void}
   * @author mxw
   * @Date 2022/6/1
   */
  static asyncFn(e, o = 0) {
    const r = setTimeout(() => {
      e(), clearTimeout(r);
    }, o);
  }
  /**
   * 防抖函数
   *
   * @params fn 函数
   * @params delay 延迟时间
   * @return {Function}
   * @author mxw
   * @Date 2023/1/11
   */
  static debounce(e, o = 300) {
    let r;
    return function(...s) {
      const l = {};
      r && clearTimeout(r), r = setTimeout(function() {
        e.apply(l, s);
      }, o);
    };
  }
}
class d {
  /**
   * 类型判断
   *
   * @param {any} obj 对比数据
   * @param {string} type 对比类型
   * @return {boolean}
   * @author mxw
   * @Date 2021/12/7
   */
  static equal(e, o) {
    return Object.prototype.toString.call(e).indexOf(o) > -1;
  }
}
const ee = S({
  name: "ImgPreview",
  components: {
    BaseIcon: K
  },
  props: {
    images: {
      type: [String, Array],
      default: ""
    },
    index: {
      type: Number,
      default: 0
    },
    keyword: {
      type: String,
      default: "url"
    },
    close: {
      type: Function,
      default: null
    },
    zoom: {
      type: Number,
      default: 1.2,
      validator(t) {
        return t > 1 && t <= 1.5;
      }
    }
  },
  setup(t) {
    const e = q({
      rotate: 0,
      rotateX: 0,
      rotateY: 0,
      scale: 1,
      imgTop: 0,
      imgLeft: 0,
      // 按下鼠标时当前鼠标所在位置
      startPageX: 0,
      startPageY: 0,
      currentImage: "",
      currentIndex: 0,
      animate: !0
    }), o = L(() => d.equal(t.images, "Array") ? "Array" : "String"), r = L(() => {
      var c;
      return o.value === "Array" ? t.index < 0 || t.index > ((c = t.images) == null ? void 0 : c.length) - 1 ? t.images[0] : t.images[t.index] : t.images;
    }), s = L(() => d.equal(e.currentImage, "Object") ? "Object" : "String");
    H(() => {
      e.currentIndex = t.index, e.currentImage = r.value;
    }), j(() => {
      document.removeEventListener("mouseup", $, !1);
    });
    const l = () => {
      t.close && t.close();
    }, a = () => {
      e.scale <= 3 && (e.scale = T.sum(e.scale, u()));
    }, n = () => {
      e.scale >= 0.6 && (e.scale = T.sub(e.scale, u()));
    };
    function u() {
      const c = "#zoom=";
      return s.value === "String" && e.currentImage.includes(c) && e.currentImage.split(c).pop() * 1 - 1 || t.zoom - 1;
    }
    const g = () => {
      var c;
      e.currentIndex === 0 ? e.currentIndex = ((c = t.images) == null ? void 0 : c.length) - 1 : e.currentIndex -= 1, e.currentImage = t.images[e.currentIndex], b();
    }, E = () => {
      var c;
      e.currentIndex === ((c = t.images) == null ? void 0 : c.length) - 1 ? e.currentIndex = 0 : e.currentIndex += 1, e.currentImage = t.images[e.currentIndex], b();
    }, v = (c) => {
      c.wheelDelta > 0 ? a() : n();
    }, i = (c) => {
      e.rotate += c;
    }, X = () => {
      e.rotateX = e.rotateX === 0 ? 180 : 0;
    }, Y = () => {
      e.rotateY = e.rotateY === 0 ? 180 : 0;
    }, O = (c) => {
      e.currentIndex !== c && (e.currentIndex = c, e.currentImage = t.images[e.currentIndex], b());
    };
    function b() {
      e.animate = !1, e.scale = 1, e.rotate = 0, e.rotateX = 0, e.rotateY = 0, e.imgLeft = 0, e.imgTop = 0, Q.asyncFn(() => {
        e.animate = !0;
      });
    }
    const A = (c) => {
      const { pageX: z, pageY: I } = c;
      e.startPageX = z - e.imgLeft, e.startPageY = I - e.imgTop, document.addEventListener("mousemove", N, !1), document.addEventListener("mouseup", $, !1), c.preventDefault();
    }, N = (c) => {
      const { pageX: z, pageY: I } = c;
      e.imgTop = I - e.startPageY, e.imgLeft = z - e.startPageX, c.preventDefault();
    }, $ = () => {
      document.removeEventListener("mousemove", N, !1);
    };
    return {
      ...P(e),
      imagesType: o,
      defaultImage: r,
      currentImageType: s,
      closeEvent: l,
      largeEvent: a,
      smallEvent: n,
      prevEvent: g,
      nextEvent: E,
      scaleEvent: v,
      rotateEvent: i,
      rotateXEvent: X,
      rotateYEvent: Y,
      resetImage: b,
      currentImageEvent: O,
      mousedownEvent: A
    };
  }
});
const te = ["src"], oe = { class: "options" }, ne = {
  key: 1,
  class: "imgs"
}, re = ["onClick"], se = ["src"];
function ae(t, e, o, r, s, l) {
  const a = x("BaseIcon");
  return f(), h("div", {
    class: "img-preview",
    onWheel: e[11] || (e[11] = (...n) => t.scaleEvent && t.scaleEvent(...n))
  }, [
    m("img", {
      class: k(["image-view", { "no-animate": !t.animate }]),
      style: D({ transform: `rotate(${t.rotate}deg) rotateX(${t.rotateX}deg) rotateY(${t.rotateY}deg) scale(${t.scale})`, top: `${t.imgTop}px`, left: `${t.imgLeft}px` }),
      src: t.currentImageType === "Object" ? t.currentImage[t.keyword] : t.currentImage,
      onMousedown: e[0] || (e[0] = (...n) => t.mousedownEvent && t.mousedownEvent(...n))
    }, null, 46, te),
    m("div", {
      class: "close button",
      onClick: e[1] || (e[1] = (...n) => t.closeEvent && t.closeEvent(...n))
    }, [
      p(a, { icon: "close" })
    ]),
    t.imagesType === "Array" && t.images.length > 1 ? (f(), h(C, { key: 0 }, [
      m("div", {
        class: "arrow arrow-left button",
        onClick: e[2] || (e[2] = (...n) => t.prevEvent && t.prevEvent(...n))
      }, [
        p(a, { icon: "arrow-left" })
      ]),
      m("div", {
        class: "arrow arrow-right button",
        onClick: e[3] || (e[3] = (...n) => t.nextEvent && t.nextEvent(...n))
      }, [
        p(a, { icon: "arrow-right" })
      ])
    ], 64)) : _("", !0),
    m("div", oe, [
      m("div", {
        class: "option button",
        onClick: e[4] || (e[4] = (...n) => t.largeEvent && t.largeEvent(...n))
      }, [
        p(a, { icon: "large" })
      ]),
      m("div", {
        class: "option button",
        onClick: e[5] || (e[5] = (...n) => t.smallEvent && t.smallEvent(...n))
      }, [
        p(a, { icon: "small" })
      ]),
      m("div", {
        class: "option button",
        onClick: e[6] || (e[6] = (n) => t.rotateEvent(-90))
      }, [
        p(a, { icon: "turn-left" })
      ]),
      m("div", {
        class: "option button",
        onClick: e[7] || (e[7] = (...n) => t.resetImage && t.resetImage(...n))
      }, [
        p(a, { icon: "ratio" })
      ]),
      m("div", {
        class: "option button",
        onClick: e[8] || (e[8] = (n) => t.rotateEvent(90))
      }, [
        p(a, { icon: "turn-right" })
      ]),
      m("div", {
        class: "option button",
        style: { "font-size": "16px" },
        onClick: e[9] || (e[9] = (...n) => t.rotateXEvent && t.rotateXEvent(...n))
      }, [
        p(a, { icon: "flip-v" })
      ]),
      m("div", {
        class: "option button",
        style: { "font-size": "16px" },
        onClick: e[10] || (e[10] = (...n) => t.rotateYEvent && t.rotateYEvent(...n))
      }, [
        p(a, { icon: "flip-h" })
      ])
    ]),
    t.imagesType === "Array" && t.images.length > 1 ? (f(), h("div", ne, [
      (f(!0), h(C, null, F(t.images, (n, u) => (f(), h("div", {
        class: k(["img button", { selected: t.currentIndex === u }]),
        key: u,
        onClick: (g) => t.currentImageEvent(u)
      }, [
        m("img", {
          src: t.currentImageType === "Object" ? n[t.keyword] : n
        }, null, 8, se)
      ], 10, re))), 128))
    ])) : _("", !0)
  ], 32);
}
const le = /* @__PURE__ */ M(ee, [["render", ae], ["__scopeId", "data-v-a123ab81"]]), ce = S({
  name: "Vue3ImagePreview",
  props: {
    zoom: {
      type: Number,
      default: 1.2,
      validator(t) {
        return t > 1 && t <= 1.5;
      }
    }
  },
  setup(t) {
    const e = q({
      imgsRef: null
    }), o = (r) => {
      if (r.target.tagName === "IMG") {
        const s = e.imgsRef.querySelectorAll("img");
        if (s.length > 1) {
          const l = [];
          s.forEach((u) => {
            l.push(u.src);
          });
          let a = -1, n = !0;
          for (; n; )
            a += 1, n = s[a] !== r.target;
          w({ images: l, index: a, zoom: t.zoom });
        } else
          w({ images: r.target.src, zoom: t.zoom });
      }
    };
    return {
      ...P(e),
      imageClickEvent: o
    };
  }
});
function ie(t, e, o, r, s, l) {
  return f(), h("div", {
    class: "image-wrapper",
    ref: "imgsRef",
    onClick: e[0] || (e[0] = (...a) => t.imageClickEvent && t.imageClickEvent(...a))
  }, [
    R(t.$slots, "default", {}, void 0, !0)
  ], 512);
}
const B = /* @__PURE__ */ M(ce, [["render", ie], ["__scopeId", "data-v-2cd4f323"]]);
window._iconfont_svg_string_3852943 = '<svg><symbol id="icon-flip-h" viewBox="0 0 1024 1024"><path d="M469.333 42.667h85.334v938.666h-85.334V42.667z m-384 153.002L401.664 512 85.334 828.33V195.67z m853.334 632.662L622.336 512l316.33-316.33v632.66z m-85.334-426.667L742.997 512l110.336 110.336V401.664z"  ></path></symbol><symbol id="icon-flip-v" viewBox="0 0 1024 1024"><path d="M981.333 469.333v85.334H42.667v-85.334h938.666z m-153.002-384L512 401.664 195.67 85.334h632.66zM195.669 938.667L512 622.336l316.33 316.33H195.67z m426.667-85.334L512 742.997 401.664 853.333h220.672z"  ></path></symbol><symbol id="icon-large" viewBox="0 0 1024 1024"><path d="M970.837 919.85L765.141 714.198a382.421 382.421 0 0 0 88.192-244.864 384 384 0 0 0-384-384 384 384 0 0 0-384 384 384 384 0 0 0 384 384 382.421 382.421 0 0 0 244.907-88.192l205.653 205.654a36.053 36.053 0 0 0 50.987 0 36.267 36.267 0 0 0-0.043-50.944zM590.72 756.865c-38.4 16.256-79.19 24.448-121.387 24.448a311.296 311.296 0 0 1-220.586-91.392 311.296 311.296 0 0 1-91.435-220.587 311.296 311.296 0 0 1 91.435-220.586 311.296 311.296 0 0 1 220.586-91.392 311.296 311.296 0 0 1 220.587 91.392 311.296 311.296 0 0 1 91.435 220.586 311.296 311.296 0 0 1-91.392 220.587 310.187 310.187 0 0 1-99.243 66.901z"  ></path><path d="M652.672 431.83h-147.84V292.01a35.968 35.968 0 1 0-71.979 0v139.82H292.011a35.968 35.968 0 1 0 0 72.02h140.8v140.8a35.968 35.968 0 1 0 72.021 0v-140.8h147.84a35.968 35.968 0 1 0 0-72.02z"  ></path></symbol><symbol id="icon-small" viewBox="0 0 1024 1024"><path d="M970.837 919.85L765.141 714.198a382.421 382.421 0 0 0 88.192-244.864 384 384 0 0 0-384-384 384 384 0 0 0-384 384 384 384 0 0 0 384 384 382.421 382.421 0 0 0 244.907-88.192l205.653 205.654a36.053 36.053 0 0 0 50.987 0 36.267 36.267 0 0 0-0.043-50.944zM590.72 756.865c-38.4 16.256-79.19 24.448-121.387 24.448a311.296 311.296 0 0 1-220.586-91.392 311.296 311.296 0 0 1-91.435-220.587 311.296 311.296 0 0 1 91.435-220.586 311.296 311.296 0 0 1 220.586-91.392 311.296 311.296 0 0 1 220.587 91.392 311.296 311.296 0 0 1 91.435 220.586 311.296 311.296 0 0 1-91.392 220.587 310.187 310.187 0 0 1-99.243 66.901z"  ></path><path d="M652.672 431.83H292.011a35.968 35.968 0 1 0 0 72.02h360.661a35.968 35.968 0 1 0 0-72.02z"  ></path></symbol><symbol id="icon-close" viewBox="0 0 1024 1024"><path d="M155.003 868.997c-21.969-21.97-21.969-60.415 0-82.384l631.61-631.61c21.97-21.969 60.415-21.969 82.384 0s21.969 60.415 0 82.384l-631.61 631.61c-21.97 21.969-60.415 21.969-82.384 0z"  ></path><path d="M155.003 155.003c21.97-21.969 60.415-21.969 82.384 0l631.61 631.61c21.969 21.97 21.969 60.415 0 82.384s-60.415 21.969-82.384 0l-631.61-631.61c-21.969-21.97-21.969-60.415 0-82.384z"  ></path></symbol><symbol id="icon-turn-left" viewBox="0 0 1024 1024"><path d="M672 418H144c-17.7 0-32 14.3-32 32v414c0 17.7 14.3 32 32 32h528c17.7 0 32-14.3 32-32V450c0-17.7-14.3-32-32-32z m-44 402H188V494h440v326z m191.3-491.5c-78.8-100.7-196-153.6-314.6-154.2l-0.2-64c0-6.5-7.6-10.1-12.6-6.1l-128 101c-4 3.1-3.9 9.1 0 12.3L492 318.6c5.1 4 12.7 0.4 12.6-6.1v-63.9c12.9 0.1 25.9 0.9 38.8 2.5 42.1 5.2 82.1 18.2 119 38.7 38.1 21.2 71.2 49.7 98.4 84.3 27.1 34.7 46.7 73.7 58.1 115.8 11 40.7 14 82.7 8.9 124.8-0.7 5.4-1.4 10.8-2.4 16.1h74.9c14.8-103.6-11.3-213-81-302.3z"  ></path></symbol><symbol id="icon-turn-right" viewBox="0 0 1024 1024"><path d="M480.5 251.2c13-1.6 25.9-2.4 38.8-2.5v63.9c0 6.5 7.5 10.1 12.6 6.1L660 217.6c4-3.2 4-9.2 0-12.3l-128-101c-5.1-4-12.6-0.4-12.6 6.1l-0.2 64c-118.6 0.5-235.8 53.4-314.6 154.2-69.6 89.2-95.7 198.6-81.1 302.4h74.9c-0.9-5.3-1.7-10.7-2.4-16.1-5.1-42.1-2.1-84.1 8.9-124.8 11.4-42.2 31-81.1 58.1-115.8 27.2-34.7 60.3-63.2 98.4-84.3 37-20.6 76.9-33.6 119.1-38.8zM880 418H352c-17.7 0-32 14.3-32 32v414c0 17.7 14.3 32 32 32h528c17.7 0 32-14.3 32-32V450c0-17.7-14.3-32-32-32z m-44 402H396V494h440v326z"  ></path></symbol><symbol id="icon-arrow-right" viewBox="0 0 1024 1024"><path d="M269.952 147.936c0-14.88 11.904-28.272 23.312-39.68 11.904-11.904 37.2-37.2 63.488-11.904l377.952 377.952c8.928 8.928 19.84 22.816 19.84 37.696s-10.912 28.768-19.84 37.696L356.752 927.648c-10.416 10.416-21.824 13.392-34.224 8.928-9.424-3.472-18.352-11.408-28.768-21.824-14.384-14.384-21.824-28.768-21.824-41.168 0-7.936 2.976-15.872 9.424-21.824L621.12 512 281.36 171.744c-7.44-7.44-11.408-15.376-11.408-23.808z"  ></path></symbol><symbol id="icon-ratio" viewBox="0 0 1024 1024"><path d="M870.4 256.512V768H154.112V256.512H870.4m15.872-64H137.728c-26.624 0-47.616 21.504-47.616 47.616v544.256c0 26.624 21.504 47.616 47.616 47.616h748.544c26.624 0 47.616-21.504 47.616-47.616V240.128c0.512-26.624-20.992-47.616-47.616-47.616z"  ></path><path d="M338.432 355.328c2.56-1.024 6.144-2.048 9.728-2.048h51.2c5.12 0 7.68 2.56 7.68 7.68v302.08c0 5.12-2.56 7.68-7.68 7.68h-48.64c-5.12 0-7.68-2.56-7.68-7.68V412.672c0-2.56-1.024-3.072-3.072-2.56l-39.936 8.192c-5.632 1.024-8.704-1.536-8.704-6.656v-30.72c0-4.096 2.048-6.656 6.144-8.704l40.96-16.896zM558.08 508.416c-8.192 7.68-17.92 11.776-29.696 11.776s-21.504-4.096-29.696-11.776c-7.68-7.68-11.776-16.896-11.776-28.16 0-10.752 4.096-19.968 12.8-27.648s17.92-11.776 28.672-11.776 20.48 4.096 29.184 11.776 12.8 16.896 12.8 27.648c0 10.752-4.096 20.48-12.288 28.16z m0 148.48c-8.192 7.68-17.92 11.264-29.696 11.264s-21.504-3.584-29.696-11.264c-7.68-7.68-11.776-16.896-11.776-27.648s4.096-19.968 12.8-27.648 17.92-11.776 28.672-11.776 20.48 4.096 29.184 11.776 12.8 16.896 12.8 27.648c0 10.752-4.096 19.968-12.288 27.648z m106.496-301.568c2.56-1.024 6.144-2.048 9.728-2.048h51.2c5.12 0 7.68 2.56 7.68 7.68v302.08c0 5.12-2.56 7.68-7.68 7.68h-48.64c-5.12 0-7.68-2.56-7.68-7.68V412.672c0-2.56-1.024-3.072-3.072-2.56l-39.936 8.192c-5.632 1.024-8.704-1.536-8.704-6.656v-30.72c0-4.096 2.048-6.656 6.144-8.704l40.96-16.896z"  ></path></symbol><symbol id="icon-arrow-left" viewBox="0 0 1024 1024"><path d="M753.29 874.923c0 14.834-11.867 28.184-23.24 39.556-11.866 11.867-37.083 37.083-63.288 11.867L289.994 549.578c-8.9-8.9-19.778-22.745-19.778-37.578s10.878-28.678 19.778-37.578L666.762 97.654c10.383-10.383 21.755-13.35 34.116-8.9 9.395 3.462 18.295 11.373 28.678 21.756 14.339 14.339 21.756 28.678 21.756 41.04 0 7.91-2.967 15.821-9.395 21.755L403.222 512l339.19 339.19c6.922 7.416 10.878 15.328 10.878 23.733z"  ></path></symbol></svg>', function(t) {
  var o = (o = document.getElementsByTagName("script"))[o.length - 1], e = o.getAttribute("data-injectcss"), o = o.getAttribute("data-disable-injectsvg");
  if (!o) {
    var r, s, l, a, n, u = function(v, i) {
      i.parentNode.insertBefore(v, i);
    };
    if (e && !t.__iconfont__svg__cssinject__) {
      t.__iconfont__svg__cssinject__ = !0;
      try {
        document.write("<style>.svgfont {display: inline-block;width: 1em;height: 1em;fill: currentColor;vertical-align: -0.1em;font-size:16px;}</style>");
      } catch (v) {
        console && console.log(v);
      }
    }
    r = function() {
      var v, i = document.createElement("div");
      i.innerHTML = t._iconfont_svg_string_3852943, (i = i.getElementsByTagName("svg")[0]) && (i.setAttribute("aria-hidden", "true"), i.style.position = "absolute", i.style.width = 0, i.style.height = 0, i.style.overflow = "hidden", i = i, (v = document.body).firstChild ? u(i, v.firstChild) : v.appendChild(i));
    }, document.addEventListener ? ~["complete", "loaded", "interactive"].indexOf(document.readyState) ? setTimeout(r, 0) : (s = function() {
      document.removeEventListener("DOMContentLoaded", s, !1), r();
    }, document.addEventListener("DOMContentLoaded", s, !1)) : document.attachEvent && (l = r, a = t.document, n = !1, E(), a.onreadystatechange = function() {
      a.readyState == "complete" && (a.onreadystatechange = null, g());
    });
  }
  function g() {
    n || (n = !0, l());
  }
  function E() {
    try {
      a.documentElement.doScroll("left");
    } catch {
      return void setTimeout(E, 50);
    }
    g();
  }
}(window);
let y = null;
function w(t) {
  if (y)
    return;
  ve();
  const e = G(le, {
    images: t.images,
    index: t.index,
    keyword: t.key,
    zoom: t.zoom,
    close: me
  });
  y = document.createElement("div"), document.body.appendChild(y), e.mount(y);
}
function me() {
  y && (document.body.removeChild(y), de(), y = null);
}
function V(t, e) {
  return function(o) {
    const { cls: r, zoom: s } = e;
    if (r) {
      const l = document.querySelectorAll(`.${r}`);
      if (l.length > 1) {
        const a = [];
        l.forEach((g) => {
          a.push(g.src);
        });
        let n = -1, u = !0;
        for (; u; )
          n += 1, u = l[n] !== t;
        w({ images: a, index: n, zoom: s });
      } else
        w({ images: o.target.src, zoom: s });
    } else
      w({ images: o.target.src, zoom: s });
  };
}
const ue = {
  mounted(t, e) {
    if (t.tagName === "IMG") {
      t.style.cursor = "pointer", t.className = "image-preview-el";
      const o = {
        cls: "",
        zoom: 1.2
      };
      if (e != null && e.arg)
        (e == null ? void 0 : e.arg) === "name" ? (d.equal(e.value, "Number") || d.equal(e.value, "String")) && (o.cls = `image-preview-el-${e.value}`, t.classList.add(o.cls)) : (e == null ? void 0 : e.arg) === "zoom" && d.equal(e.value, "Number") && e.value > 1 && e.value <= 1.5 && (o.zoom = e.value);
      else if (d.equal(e.value, "String"))
        (d.equal(e.value, "Number") || d.equal(e.value, "String")) && (o.cls = `image-preview-el-${e.value}`, t.classList.add(o.cls));
      else if (d.equal(e.value, "Object") && (e.value.hasOwnProperty("name") || e.value.hasOwnProperty("zoom"))) {
        const r = e.value.name, s = e.value.zoom;
        (d.equal(r, "Number") || d.equal(r, "String")) && (o.cls = `image-preview-el-${r}`, t.classList.add(o.cls)), d.equal(s, "Number") && s > 1 && s <= 1.5 && (o.zoom = s, t.src = `${t.src}#zoom=${s}`);
      }
      t.addEventListener("click", V(t, o), !1);
    }
  },
  unmounted(t) {
    t.tagName === "IMG" && t.removeEventListener("click", V(null, null), !1);
  }
};
function de() {
  document.documentElement.classList.remove("vue3-image-preview-disabled-scroll"), document.body.classList.remove("vue3-image-preview-disabled-scroll");
}
function ve() {
  document.documentElement.classList.add("vue3-image-preview-disabled-scroll"), document.body.classList.add("vue3-image-preview-disabled-scroll");
}
const ge = {
  install(t) {
    t.component(B.name, B), t.directive("preview", ue), t.config.globalProperties.preview = w;
  }
};
export {
  B as Vue3ImagePreview,
  ge as default,
  w as preview,
  ue as vPreview
};
